const availableAnnouncements = {
  'auction-access-banner': {
    key: 'auction-access-banner',
    priority: 0,
  },
  'eula-review-banner': {
    key: 'eula-review-banner',
    priority: 1,
    hiddenOnDesktop: true,
  },
};

const announcementKeys = Object.keys(availableAnnouncements);

export const actions = {
  updateAnnouncement({ commit }, announcement = {}) {
    commit('setAnnouncement', announcement);
  },
  removeAnnouncementByKey({ commit }, key) {
    commit('removeAnnouncement', key);
  },
  resetAnnouncements({ commit }) {
    commit('resetAnnouncements');
  },
};

export const mutations = {
  setAnnouncement(state, announcement) {
    if (announcementKeys.includes(announcement.key)) {
      // If the announcement already exists, update it
      const foundAnnouncementIndex = state.announcements.findIndex(
        (a) => a.key === announcement.key,
      );

      if (foundAnnouncementIndex > -1) {
        state.announcements[foundAnnouncementIndex] = {
          ...state.announcements[foundAnnouncementIndex],
          ...announcement,
        };
      } else {
        // If it doesn't exist, add it
        state.announcements.push({
          ...availableAnnouncements[announcement.key], // default properties
          ...announcement,
        });
      }
    }
  },

  removeAnnouncement(state, key) {
    if (announcementKeys.includes(key)) {
      // Remove the announcement by key
      state.announcements = state.announcements.filter(
        (announcement) => announcement.key !== key,
      );
    }
  },

  resetAnnouncements(state) {
    state.announcements = [];
  },
};

export const getters = {
  hasMobileAnnouncements: (state) => !!state.announcements.length,
  hasDesktopAnnouncements: (state) => !!state.announcements
    .filter((a) => !a.hiddenOnDesktop).length,
};

export const state = {
  announcements: [],
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
